// Realms that should be shown in explore/menu even though they are not primary
export const whiteListedRealms = ['merge', '3doodler', 'pltw'];

// Realms that should NOT be shown in explore/menu unless currently selected
export const blackListedRealms = ['texas', 'atlanta'];
